function adjustFooterBlockHeight() {
    document.querySelectorAll('.footer-block').forEach(footerBlock => {
      const heading = footerBlock.querySelector('.footer-block__heading');
      const content = footerBlock.querySelector('.footer-block__details-content');
      let isActive = footerBlock.classList.contains('active'); 
      const resizeHandler = () => {
        footerBlock.style.height = window.matchMedia('(min-width: 750px)').matches ? 'fit-content' : (isActive ? `${content.scrollHeight + 40}px` : '40px');
      };
      if (isActive) {
        footerBlock.style.height = `${content.scrollHeight + 40}px`;
      } else {
        footerBlock.style.height = '40px';
      }
      heading.addEventListener('click', () => {
        isActive = footerBlock.classList.toggle('active');
        footerBlock.style.height = isActive ? `${content.scrollHeight + 40}px` : '40px';
      });
      window.addEventListener('resize', resizeHandler);
      resizeHandler();
    });
  }
  adjustFooterBlockHeight();
  